export default class MemberContractState {
    constructor(status, contractType) {

        this.status = status;
        this.contractType = contractType;
    }
}
